import {combine} from 'effector';

import {loadGridCsv} from 'api';
import {fetchGtinsGrid} from 'api/registries';
import {getPackagingFormatType, setFavorite, setFavorites} from 'api/registries/gtins';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {SimplePaginationContent} from 'types/api';
import {GtinsGridRawRow, PackagingFormatType} from 'types/gtins';

const domain = rootDomain.createDomain('GtinsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchGtinsGrid,
});

export const fetchCsv = domain.createEffect({
    name: 'fetchRegistriesCsv',
    handler: loadGridCsv,
});

export const getPackagingFormatTypeFx = domain.createEffect({
    name: 'getPackagingFormatTypeFx',
    handler: getPackagingFormatType,
});

export const setFavoriteFx = domain.createEffect({
    name: 'setFavoriteFx',
    handler: setFavorite,
});
export const favoriteToggled = domain.createEvent<{gtin: string; currentStatus?: boolean}>();

export const setFavoritesFx = domain.createEffect({
    name: 'setFavoritesFx',
    handler: setFavorites,
});
export const favoritesSubmitted = domain.createEvent<{gtins: string[]; status: boolean}>();

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({domain});

export const data$ = domain.createStore<SimplePaginationContent<GtinsGridRawRow> | null>(null);

export const packagingFormatTypeDictionary$ = domain.createStore<PackagingFormatType[]>([]);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore<string>('');

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    isLoading: fetchDataFx.pending,
    favoritesPending: setFavoritesFx.pending,
    exportPending: fetchCsv.pending,
});
